import React from 'react';

const useBigTradesTableData = ({trades}: any) => {

  // table memoized required fields
  const data = React.useMemo(
    () => trades,
    [trades]
  );
  const columns = React.useMemo(
    () => [
      {
        id: 'ticker',
        Header: 'Pair',
        accessor: 'ticker',
      },
      {
        id: 'time',
        Header: 'Time',
        accessor: 'timestamp',
      },
      {
        id: 'buy',
        Header: 'Type',
        accessor: 'buy',
      },
      {
        id: 'amount_base',
        Header: 'Amount Base',
        accessor: 'amount_base',
      },{
        id: 'amount_quote',
        Header: 'Amount Quote',
        accessor: 'amount_quote',
      },
      {
        id: 'price_a_usd',
        Header: 'Price USD',
        accessor: 'price_a_usd',
      },
      {
        id: 'value_usd',
        Header: 'Value',
        accessor: 'value_usd',
      },
      {
        id: 'wallet',
        Header: 'Wallet',
        accessor: 'wallet',
      }
    ], []
  );

  return {columns, data};
};

export { useBigTradesTableData };

